/* eslint-disable no-unused-vars */

import { Grid } from '@material-ui/core'
import { Typography,Container, useMediaQuery, useTheme, createTheme } from '@mui/material'
import React from 'react'
import ValueCard from './ValueCard'
import Slider from "react-slick";
import Header from '../content-component/Header';

const imageBaseUrl = process.env.REACT_APP_IMAGE_URL

const icon1 =imageBaseUrl + 'value1.svg';
const icon2 =imageBaseUrl + 'value2.svg';
const icon3 =imageBaseUrl + 'value3.svg';
const icon4 =imageBaseUrl + 'value4.svg';


const OurValue = () => {
    const theme = useTheme();
    const isSmScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
    const isFullScreen = useMediaQuery((theme) => theme.breakpoints.down("lg"));
    const isMediumScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
    const largeScreen = createTheme({
      breakpoints: {
        values: {
          xxl: 1920,
        },
      },
    });
    const isLargeScreen = useMediaQuery(largeScreen.breakpoints.up("xxl"));

    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: isSmScreen ? 1 : 4,
        slidesToScroll: 3,
        arrows: isMediumScreen ?  true : isSmScreen ? true : false ,
        autoPlay: true,
        autoplaySpeed: 500,
        adaptiveHeight:true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
        
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
         
            },
          },
        ],
      };

    const valueCardData = [
        {
          id: 1,
          icon: icon1,
          title: "Local Experts with Global Knowledge",
          about: "Our team in Kolkata understands both the local education system and international study opportunities. We help you connect with the world’s top universities."
        },
        {
          id: 2,
          icon: icon2,
          title: "Personalized Guidance for Every Student",
          about: "Every student is different, and we create a plan just for you. We take the time to understand your interests, strengths, and challenges to find the best path for your future."
        },
        {
          id: 3,
          icon: icon3,
          title: "Proven Success",
          about : "With years of experience, we have helped many students get into top universities worldwide. Our strong network and expert advice ensure you are on the right track."
        },
        {
          id: 4,
          icon: icon4,
          title: "Helping You Adapt to a New Culture",
          about: "Kolkata is a diverse city, and we use this experience to prepare you for life in a new country. We make sure your transition is smooth and enjoyable.With us, your study abroad journey starts with confidence. Let’s make your dreams a reality!"
        },
      ];
    return (
        <Container 
        sx={{
          // marginTop:'5vh',
          padding:"50px 0",
          height : "auto",
          // height: {xs:'auto',md:'100vh',lg:'90vh',xl:'80vh', xxl: '80vh'},
          // width: {xs:'80%',lg:'auto'},
          width : "100%"
        }}
        maxWidth={isLargeScreen?"xl":"lg"}
        >
        <Grid container
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            direction="column"
        > 
        {/* <Header
                        color="#00999e"
                        textAlign="center"
                        content="Why Choose Our MBBS Abroad Services? "
                    /> */}
        <Typography
            variant="h2"
            gutterBottom
            sx={{
                color: "#00999E",
                fontSize: "36px",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "normal",
                textTransform: "capitalize",
                textAlign: "center",
                mb:4
            }}
        >
          ~Why Choose Our MBBS Abroad Services? ~
        </Typography>
       {  <Typography
            variant="subtitle1"
            gutterBottom
            sx={{
                color: "#1E1E1E",
                fontSize: { xs: "14px", sm: "18px", md: "20px", lg: "19px" },
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "1.5",
                textTransform: "capitalize",
                textAlign: "center",
                width: { xs: "100%", sm: "80%", md: "80%", lg: "80%" },
                margin: "auto"
            }}
        >
            Kolkata is a city full of history, culture, and great education. It’s a place where students dream big, and we are here to help make those dreams come true. We are proud to serve this dynamic community by:  
          </Typography>}

        <Container
        style={{ 
            height: "100%",
            // padding: "60px 0",
            justifyContent: isSmScreen?"center":isMediumScreen?"center":"space-between",
            alignItems:"center",
        }}
        maxWidth={isLargeScreen?"xl":"auto"}
        ><div
        style={{
            gap: "2rem",
            justifyContent: "center",
            margin:"auto",
            height: "415px",
            display: "flex"
        }}
    > <Slider {...settings} >
            {
                valueCardData.map((card)=>(
                    <ValueCard 
                    key={card.id}
                    id={card.id}  
                    icon={card.icon}
                    title={card.title}
                    about={card.about}
                    />
                ))
            }
            </Slider>
            </div>
        </Container>
    </Grid>
        </Container>
    )
}

export default OurValue